import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MyErrorStateMatcher } from 'src/app/auth/login/login.component';
import { ContractService } from 'src/app/contract/shared/contract.service';
import { UserService } from 'src/app/shared/user.service';

@Component({
  selector: 'app-add-signatory',
  templateUrl: './add-signatory.component.html',
  styleUrl: './add-signatory.component.css'
})
export class AddSignatoryComponent implements OnInit {
  matcher = new MyErrorStateMatcher();
  signatoryForm: FormGroup;
  users: any;
  isLoading: boolean = false;
  initialFormValue: any; // To track form changes

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public userService: UserService, private toast: ToastrService, private contractService: ContractService, private dialogRef: MatDialogRef<AddSignatoryComponent>, private fb: FormBuilder) {
    this.signatoryForm = this.fb.group({
      contractId: new FormControl(this.data?.id || '', [Validators.required]),
      users: [this.data.isResponsiblePerson ? null : [], this.data.isResponsiblePerson ? [Validators.required] : []],
      additionalSignatories: this.fb.array([])
    });

    if (this.data.isEdit && this.data.currentSignatory) {
      this.addSignatory();
      const signatory = this.additionalSignatories.at(0);
      signatory.patchValue({
        name: this.data.currentSignatory.Name,
        email: this.data.currentSignatory.EmailId
      });
      // Store initial form value for comparison
      this.initialFormValue = this.signatoryForm.value;
    }
  }

  get additionalSignatories() {
    return this.signatoryForm.get('additionalSignatories') as FormArray;
  }

  async ngOnInit() {
    await this.userService.getAllTenantUsers().then((res) => {
      this.users = res as Array<Object>;
    });
  }

  // Add method to check if form has changed
  hasFormChanged(): boolean {
    if (!this.data.isEdit) {
      // For new signatories, check if any data is entered
      return this.signatoryForm.dirty && this.signatoryForm.valid;
    }
    
    // For edit mode, compare current value with initial value
    const currentValue = this.signatoryForm.value;
    return JSON.stringify(currentValue) !== JSON.stringify(this.initialFormValue);
  }

  async add() {
    if (this.signatoryForm.valid) {
      this.isLoading = true;
      const data = this.signatoryForm.value;
      let signatoryCount = 0;

      if (this.data.isEdit) {
        const signatory = data.additionalSignatories[0];
        const success = this.data.addFunction(signatory.name, signatory.email, false);
        if (success) {
          if (!this.data.isResponsiblePerson) {
            this.toast.success('Signatory updated successfully!');
          }
          this.dialogRef.close(true);
        }
        this.isLoading = false;
        return;
      }

      // Add selected users from dropdown
      if (data.users && (Array.isArray(data.users) ? data.users.length > 0 : data.users)) {
        // Handle both single selection (for responsible person) and multiple selection (for signatories)
        const userIds = Array.isArray(data.users) ? data.users : [data.users];
        
        userIds.forEach(userId => {
          const user = this.users.find(u => u.id === userId);
          if (user) {
            const added = this.data.addFunction(
              `${user.firstName} ${user.middleName ? user.middleName + ' ' : ''}${user.lastName}`,
              user.emailAddress,
              false
            );
            if (added) signatoryCount++;
          }
        });
      }

      // Add manually entered additional signatories
      if (data.additionalSignatories && data.additionalSignatories.length > 0) {
        data.additionalSignatories.forEach(signatory => {
          const added = this.data.addFunction(signatory.name, signatory.email, true);
          if (added) signatoryCount++;
        });
      }

      if (!this.data.isResponsiblePerson) {
        if (signatoryCount > 1) {
          this.toast.success('Signatories added successfully!', '');
        } else {
          this.toast.success('Signatory added successfully!', '');
        }
      }
      
      this.dialogRef.close(true);
      this.isLoading = false;

      // await this.contractService.sendForDocuSign(data).then((res) => {
      //   this.toast.success('Signatory added successfully!', '');
      //   this.dialogRef.close();
      //   this.isLoading = false;
      // });
    }
  }

  addSignatory() {
    const signatoryForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]]
    });
    this.additionalSignatories.push(signatoryForm);
  }

  removeSignatory(index: number) {
    this.additionalSignatories.removeAt(index);
  }
}
